import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

const DEFAULT_API_HOST = "api.gong.io";

export const gong = defineConnector({
  identifier: "gong",
  name: "Gong",
  tagLine: "Revenue intelligence platform",
  keywords:
    "revenue conversation intelligence call recording transcripts sales coaching",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://([^./]+\\.)*gong\\.io/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.accessKey,
      password: app.secret.accessKeySecret,
    }),
  steps: [
    {
      title: "Get your Gong API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Gong, go to **Company Settings > Ecosystem > API** and create a new API key. You'll receive an Access Key and Access Key Secret.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "Access key",
          required: true,
          target: { kind: "configuration", field: "accessKey" },
        },
        {
          kind: "input",
          label: "Access key secret",
          required: true,
          target: { kind: "secrets", field: "accessKeySecret" },
        },
        {
          kind: "hostname",
          label: "API host",
          placeholder: DEFAULT_API_HOST,
          defaultValue: DEFAULT_API_HOST,
          target: { kind: "configuration", field: "apiHost" },
          helperText:
            "Most accounts use api.gong.io. Override only if your account has a custom Gong API domain.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiHost }) => `https://${apiHost || DEFAULT_API_HOST}/v2/users`,
  },
  publicEnvVars: ({ apiHost }) => ({
    GONG_API_URL: `https://${apiHost || DEFAULT_API_HOST}`,
  }),
});
